import { captureException, withScope } from '@sentry/react'

import getQueryStringParams from '../getQueryStringParameters'
import { ReceiverResult } from '../types'
import { receiveBec } from './InitiateFetchFromPopUpReceivers/becReceiver'
import {
	initiateFetchingFromKeyId,
	initiateFetchingFromKeyIdAndCode,
	initiateFetchingFromState,
} from './InitiateFetchFromPopUpReceivers/defaultReceiver'
import { receiveDefaultWithEventDispatcher } from './defaultReceiver'
import {
	SetInitialSentryTags,
	setIsAiia,
	setIsBankData,
	setIsBec,
	setIsNordea,
	setIsEnableBanking,
	setIsDanskeBank,
	setIsDnb,
	setIsSwedbank,
	setIsSDC,
} from './sentryTagger'
import {
	handleNordeaRedirectFailure,
	oauth2RedirectFailureHandler,
} from './oauthRedirectErrorHandler'

export const resolveAndExecuteReceiverResolver = async (
	locationPathName: string,
): Promise<ReceiverResult> => {
	const segments = locationPathName.split('/')
	const receiverTypeSegmentIndex = segments.indexOf('redirect-receiver') + 1

	const queryParameters = getQueryStringParams(window.location.search)
	let receiverType = 'default'
	if (segments.length != receiverTypeSegmentIndex) {
		receiverType = segments[receiverTypeSegmentIndex] ?? 'default'
	}

	SetInitialSentryTags()
	console.info('Receiver type: ', receiverType)
	switch (receiverType) {
		case 'default':
			console.log('Resolved default resolver')
			return receiveDefaultWithEventDispatcher(queryParameters)
		case 'bec':
			console.info('Resolved bec data resolver')
			setIsBec(true)
			return await receiveBec(queryParameters)
		case 'bankdata':
			console.info('Resolved bank data resolver')
			setIsBankData(true)
			return await initiateFetchingFromState(queryParameters)
		case 'aiia':
			console.info('Resolved Aiia resolver')
			setIsAiia(true)
			if (await oauth2RedirectFailureHandler(queryParameters)) {
				return { success: false }
			}
			return await initiateFetchingFromKeyIdAndCode(queryParameters)
		case 'nordea':
			console.info('Resolved Nordea resolver')
			setIsNordea(true)
			if (await handleNordeaRedirectFailure(queryParameters)) {
				return { success: false }
			}
			return await initiateFetchingFromState(queryParameters)
		case 'danske-bank':
			console.info('Resolved Danske Bank resolver')
			setIsDanskeBank(true)
			const urlQuery = window.location.hash.substring(1)
			const queryParamsInDanskeCase = getQueryStringParams(urlQuery)
			return await initiateFetchingFromState(queryParamsInDanskeCase)
		case 'sdc':
			console.info('Resolved SDC resolver')
			setIsSDC(true)
			return await initiateFetchingFromState(queryParameters)
		case 'lunar':
			console.info('Resolved Lunar resolver')
			if (await oauth2RedirectFailureHandler(queryParameters)) {
				return { success: false }
			}
			return await initiateFetchingFromState(queryParameters)
		case 'enable-banking':
			console.info('Resolved enable banking resolver')
			setIsEnableBanking(true)
			if (await oauth2RedirectFailureHandler(queryParameters)) {
				return { success: false }
			}
			return await initiateFetchingFromState(queryParameters)
		case 'dnb':
			console.info('Resolved dnb resolver')
			setIsDnb(true)
			return await initiateFetchingFromKeyId(queryParameters)
		case 'swedbank':
			console.info('Resolved swedbank resolver')
			setIsSwedbank(true)
			return await initiateFetchingFromState(queryParameters)

		default:
			console.error('Could not resolve redirect resolver')
			withScope((scope) => {
				scope.setLevel('warning')
				captureException(new Error('Invalid redirect receiver type'))
			})
			return { success: false }
	}
}
